import { type ComponentConfig } from '@puckeditor/core';
import { useRegisterSection } from '~/hooks/useSections';
import { MicrositeTemplate, type MicrositeProfile } from '~/model';
import ContactBlockBeta from '~/editor/templates/beta/ContactBlockBeta';
import { DEMO_PROFILES } from '~/demo';

export interface ContactBlockProps {
	navigation?: boolean;
	template: MicrositeTemplate;
	profiles: MicrositeProfile[];
}

export const PUCK_BLOCK_CONTACT: ComponentConfig<ContactBlockProps> = {
	label: 'Contact',
	fields: {
		navigation: {
			type: 'radio',
			options: [
				{ label: 'On', value: true },
				{ label: 'Off', value: false },
			],
		},
		template: {
			type: 'radio',
			options: [{ label: 'Beta', value: MicrositeTemplate.BETA }],
		},
		profiles: {
			type: 'array',
			label: 'Profiles',
			arrayFields: {
				name: {
					type: 'text',
					label: 'Name',
				},
				title: {
					type: 'text',
					label: 'Title',
				},
				company: {
					type: 'text',
					label: 'Company',
				},
				organization: {
					type: 'text',
					label: 'Organization',
				},
				phone: {
					type: 'text',
					label: 'Phone',
				},
				email: {
					type: 'text',
					label: 'Email',
				},
				website: {
					type: 'text',
					label: 'Website',
				},
				license: {
					type: 'text',
					label: 'License',
				},
			},
		},
	},
	defaultProps: {
		navigation: true,
		template: MicrositeTemplate.BETA,
		profiles: [],
	},
	render(props) {
		return <ContactBlock {...props} />;
	},
};

export default function ContactBlock({ navigation = true }: ContactBlockProps) {
	const title = 'Contact';
	const id = useRegisterSection('contact', title, navigation);

	return <ContactBlockBeta id={id} title={title} profiles={[DEMO_PROFILES[0]]} />;
}
